module.exports = __webpack_public_path__ + "img/maison10.fc5559ab.jpg";